export const CHECK = 2;
export const E_CHECK = 3;
